// @flow

import styled  from 'styled-components';

export const VoucherTitle = styled.p`
  font-size: 22px;
  font-family: "Gilroy", "Open Sans", "OpenSans", Arial, "Helvetica Neue", Helvetica,sans-serif;
  color: #2397d4;
  margin-bottom: 16px;
`;
